import moment from 'moment-timezone';
import {type Moment} from 'moment-timezone';

import {hasValue} from '@famly/stat_ts-utils_has-value';

import type * as Types from '../types';
import {calculateStartDateOfBiweeklyEndPeriod} from '../helpers/create-billing-periods';

export const transformEndDateToPlanEndDate = (endDate: Moment): string => {
    // The last day of a plan is exclusive, so it is necessary to add one day to the end date.
    return moment(endDate).add(1, 'day').format('YYYY-MM-DD');
};

export const getStartDateForEndPeriod = (
    selectedBillingFrequency: Types.State['billingFrequencyState']['selectedBillingFrequency'],
    selectedEndDate: Types.State['endDateState']['selectedEndDate'],
    biweeklyBillingStartDate: Moment,
) => {
    if (!hasValue(selectedEndDate)) {
        return null;
    }
    switch (selectedBillingFrequency?.type) {
        case 'monthly': {
            return selectedEndDate.clone().startOf('month');
        }
        case 'weekly': {
            return selectedEndDate.clone().startOf('isoWeek');
        }
        case 'biweekly': {
            return calculateStartDateOfBiweeklyEndPeriod(biweeklyBillingStartDate, selectedEndDate);
        }
        default:
            return null;
    }
};
